import * as React from "react";
const SvgPlayStore = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 24,
    viewBox: "0 0 21 24",
    fill: "none",
    ...props
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M9.80482 11.4617L0.0895996 22.0059C0.0905121 22.0078 0.090512 22.0106 0.0914244 22.0125C0.389807 23.1574 1.41179 24 2.62539 24C3.11083 24 3.56616 23.8656 3.95671 23.6305L3.98773 23.6118L14.9229 17.1593L9.80482 11.4617Z",
      fill: "#EA4335"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M19.6331 9.66619L19.624 9.65966L14.9028 6.86123L9.58392 11.7013L14.922 17.1582L19.6176 14.3878C20.4407 13.9324 21 13.045 21 12.0223C21 11.0052 20.4489 10.1225 19.6331 9.66619Z",
      fill: "#FBBC04"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M0.0894234 1.99331C0.0310244 2.21353 0 2.44494 0 2.68382V21.3163C0 21.5552 0.0310245 21.7866 0.0903359 22.0059L10.1386 11.7313L0.0894234 1.99331Z",
      fill: "#4285F4"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M9.8766 11.9999L14.9044 6.85939L3.98195 0.383537C3.58502 0.139993 3.12148 2.57492e-05 2.626 2.57492e-05C1.4124 2.57492e-05 0.388589 0.844499 0.0902064 1.99037C0.0902064 1.9913 0.0892944 1.99224 0.0892944 1.99317L9.8766 11.9999Z",
      fill: "#34A853"
    }
  )
);
export default SvgPlayStore;
